export function makeFieldsData (studentData, grades = false) {
  const fields = {}
  studentData.forEach(function(student) {
    if (student.student_exam_mark.length !== 0) {
      const markField = `enroll_mark[${student.id}][exam_mark_score]`
      const examMark = grades ? student.student_exam_mark[0].exam_mark_grade : student.student_exam_mark[0].exam_mark_score

      fields[markField] = examMark
      // ============================================== //
      fields[`enroll_mark[${student.id}][mark]`] = student.student_exam_mark[0].mark
      fields[`enroll_mark[${student.id}][theory_mark]`] = student.student_exam_mark[0].theory_mark
      fields[`enroll_mark[${student.id}][practical_mark]`] = student.student_exam_mark[0].practical_mark
      fields[`enroll_mark[${student.id}][grade]`] = student.student_exam_mark[0].grade
      fields[`enroll_mark[${student.id}][theory_grade]`] = student.student_exam_mark[0].theory_grade
      fields[`enroll_mark[${student.id}][practical_grade]`] = student.student_exam_mark[0].practical_grade
    }
  })

  return fields
}
